export enum MapProvider
{
    Google = 1,
    Yandex = 2
}